import {AiOutlineInstagram} from 'react-icons/ai'
import {FaXTwitter} from 'react-icons/fa6'
import {AiFillFacebook} from 'react-icons/ai'
import {AiFillLinkedin} from 'react-icons/ai'

export const links = [
    {id: 1, link: '#header', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    {id: 3, link: '#skills', title: 'Skills'},
    {id: 4, link: '#resume', title: 'Resumé'},
    {id: 5, link: '#portfolio', title: 'Projects'},
    {id: 6, link: '#contact', title: 'Contact'}
]


export const socials = [
    {id: 1, link: 'https://www.linkedin.com/in/josephattardfava/', icon: <AiFillLinkedin/>},
    {id: 2, link: 'https://www.instagram.com/joseph.af92', icon: <AiOutlineInstagram/>},
    {id: 3, link: 'https://x.com/joseph_af92', icon: <FaXTwitter/>},
    {id: 4, link: 'https://www.facebook.com/josephattardfava', icon: <AiFillFacebook/>}
]